module.exports = __webpack_public_path__ + "media/assets/ApprovalIcon-cd810c0d37f1cd1afb1344856d17cd56.svg";